// extracted by mini-css-extract-plugin
export default {"LoaderContainer":"ChartPanel_LoaderContainer__pv3H4","ChartContainer":"ChartPanel_ChartContainer__FQPuk"};